<template>
  <modal v-if="showModal" class="pricing-modal big-modal" :mdBackdrop="false">
    <template slot="header">
      <md-button class="md-simple md-just-icon md-round modal-default-button" @click="close">
        <md-icon>clear</md-icon>
      </md-button>
    </template>
    <template slot="body">
      <md-toolbar class="md-transparent md-theme-default md-elevation-0 md-toolbar-filters">
        <md-list style="flex-wrap: wrap;">
          <md-radio v-if="data.selected_dates.length > 0" v-model="usingSpecificDates" :value="false" class="md-no-wrap"
            >Selected Dates</md-radio
          >
          <md-radio v-model="usingSpecificDates" :value="true" class="md-no-wrap">Spefic Dates</md-radio>
        </md-list>
        <md-list v-if="usingSpecificDates" style="margin-top: 15px;">
          <date-range-picker
            :start="data.range_dates.travel_date_from"
            :end="data.range_dates.travel_date_to"
            @change="changeTravelDate"
            :displayList="true"
            :min-days="0"
            :max-days="maxDays"
            :max-months="3"
            :displayFrom="false"
            :displayTo="false"
            displayFromTo
          >
          </date-range-picker>

          <week-days-select multiple v-model="data.range_dates.days_of_weeks"></week-days-select>
        </md-list>
      </md-toolbar>
      <md-toolbar class="md-transparent md-theme-default md-elevation-0 md-toolbar-filters">
        <md-list v-if="usingSpecificDates">
          <room-type-select multiple v-model="data.range_dates.room_type_ids"></room-type-select>
          <md-field>
            <label>Online/Offline</label>
            <md-select v-model="data.channels_online" disabled>
              <md-option :value="true">Online</md-option>
              <md-option :value="false">Offline</md-option>
            </md-select>
          </md-field>
          <channel-select multiple v-model="data.channel_ids" :online="data.channels_online"></channel-select>
          <rate-select v-model="data.rate_ids" multiple></rate-select>
        </md-list>
      </md-toolbar>

      <ValidationObserver ref="validator">
        <div class="text-left">
          <div class="md-toolbar md-transparent with-border">
            <div class="w-100 md-layout">
              <div class="md-layout-item md-small-size-100 md-size-85">
                <md-switch v-model="price.enabled">Price </md-switch>
              </div>
            </div>
            <div class="w-100 md-layout" v-if="price.enabled">
              <div class="md-layout-item md-small-size-100 md-size-15">
                <ValidationProvider v-if="price.enabled" rules="required" v-slot="{ failed }">
                  <slide-y-down-transition>
                    <span v-if="failed" class="has-error">
                      <md-icon class="error">close</md-icon>
                      <small>Select one</small>
                    </span>
                  </slide-y-down-transition>
                  <md-radio v-model="absolute_price" :value="true" @change="checkPricingAction">Absolute</md-radio>
                  <md-radio v-model="absolute_price" :value="false" @change="checkPricingAction">Increment</md-radio>
                </ValidationProvider>
              </div>
              <div class="md-layout-item md-small-size-100 md-size-85">
                <ValidationProvider rules="required" v-slot="{ passed, failed }" slim>
                  <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]" style="max-width:100px;align-items: end;gap:8px;">
                    <md-input v-model="data.pricing_action.amount" style="max-width:100px;" @change="checkPricingAction"></md-input>
                    <slide-y-down-transition>
                      <md-icon class="error" v-show="failed">close</md-icon>
                    </slide-y-down-transition>
                    <template v-if="absolute_price === true">
                      <span>€</span>
                    </template>
                  </md-field>
                </ValidationProvider>
                <ValidationProvider v-if="absolute_price === false" rules="required" v-slot="{ failed }">
                  <slide-y-down-transition>
                    <span v-if="failed" class="has-error">
                      <md-icon class="error">close</md-icon>
                      <small>Select one</small>
                    </span>
                  </slide-y-down-transition>
                  <md-radio v-model="percentage_price" :value="true" @change="checkPricingAction">%</md-radio>
                  <md-radio v-model="percentage_price" :value="false" @change="checkPricingAction">€</md-radio>
                </ValidationProvider>
              </div>
            </div>
          </div>
        </div>
      </ValidationObserver>
    </template>

    <template slot="footer">
      <md-card-actions>
        <md-button v-if="price.enabled && !!data.pricing_action.amount" class="md-info" @click="sendAndClose">
          Send & Close
        </md-button>
        <md-button v-if="price.enabled && !!data.pricing_action.amount" class="md-success" @click="sendAdvancePricing">
          Send
        </md-button>
        <md-button class="md-default" @click="close">Close</md-button>
      </md-card-actions>
    </template>
  </modal>
</template>

<script>
/*eslint-disable */

import { Modal } from '@/components'
import { extend } from 'vee-validate'
import { required, numeric } from 'vee-validate/dist/rules'
import { SlideYDownTransition } from 'vue2-transitions'
import ChannelSelect from '../Inputs/ChannelSelect.vue'
import RoomTypeSelect from '../Inputs/RoomTypeSelect.vue'
import RateSelect from '../Inputs/RateSelect.vue'
import WeekDaysSelect from '../Pricing/Inputs/WeekDaysSelect.vue'
import RatesApi from '../../openapi/src/api/RatesApi'
import DateRangePicker from '@/components/Inputs/DateRangePicker.vue'

extend('required', required)
extend('numeric', numeric)

export default {
  name: 'PricingBatchModal',
  components: {
    Modal,
    ChannelSelect,
    RoomTypeSelect,
    WeekDaysSelect,
    SlideYDownTransition,
    RateSelect,
    DateRangePicker,
  },
  props: {
    hasSelectedDates: Boolean,
  },
  data() {
    return {
      data: {
        channel_ids: [],
        range_dates: {
          travel_date_from: this.moment().toDate(),
          travel_date_to: this.moment().toDate(),
        },
        pricing_action: {},
        selected_dates: [],
        channels_online: true,
        rate_ids: [],
      },
      absolute_price: null,
      percentage_price: false,
      usingSpecificDates: false,
      showModal: false,
      price: {
        enabled: false,
      },
      maxDays: 10,
    }
  },
  computed: {
    travel_window_string() {
      const options = { year: 'numeric', month: 'numeric', day: 'numeric' }

      return (
        this.data.range_dates.travel_date_from.toLocaleDateString('en-UK', options) +
        ' \u2794 ' +
        this.data.range_dates.travel_date_to.toLocaleDateString('en-UK', options)
      )
    },
  },
  methods: {
    checkPricingAction: function() {
      let value_format = 'ABSOLUTE'
      if (!this.absolute_price) {
        value_format = this.percentage_price ? 'PERCENTAGE' : 'RELATIVE'
      }
      this.data.pricing_action.value_format = value_format
    },
    open: function() {
      this.showModal = true
      this.usingSpecificDates = !this.hasSelectedDates
      this.data = Object.assign(this.data, {
        pricing_action: {},
      })

      return this
    },
    close: function() {
      this.price.enabled = false
      this.showModal = false
    },
    sendAndClose: function() {
      this.sendAdvancePricing().then((validationResponse) => {
        if (!validationResponse) return
        this.clearRoomTypeDate()
        this.close()
      })
    },
    setChannelIds: function(channel_ids) {
      this.data.channel_ids = channel_ids

      return this
    },
    setDateInterval: function(from, to) {
      this.data.range_dates.travel_date_from = from
      this.data.range_dates.travel_date_to = to

      return this
    },
    clearRoomTypeDate() {
      this.data.selected_dates = []
      this.$emit('clear')
    },
    addRoomTypeDate(room_type_id, date) {
      var index = this.data.selected_dates.findIndex((d) => d.room_type_id == room_type_id)
      var added = false
      if (index < 0) {
        this.data.selected_dates.push({
          room_type_id: room_type_id,
          dates: [date],
        })
        added = true
      } else {
        var indexDate = this.data.selected_dates[index].dates.findIndex((d) => d == date)
        if (indexDate < 0) {
          this.data.selected_dates[index].dates.push(date)
          added = true
        }
      }

      return added
    },
    removeRoomTypeDate(room_type_id, date) {
      var index = this.data.selected_dates.findIndex((d) => d.room_type_id == room_type_id)
      var removed = false
      if (index > -1) {
        var indexDate = this.data.selected_dates[index].dates.findIndex((d) => d == date)
        if (indexDate > -1) {
          this.data.selected_dates[index].dates.splice(indexDate, 1)
          removed = true
        }
        if (!this.data.selected_dates[index].dates.length) this.data.selected_dates.splice(index, 1)
      }

      return removed
    },
    async sendAdvancePricing() {
      if (await this.$refs.validator.validate()) {
        var data = Object.assign({}, this.data)
        if (this.usingSpecificDates) {
          data.selected_dates = null
        } else {
          data.range_dates = null
        }
        this.$emit('save', data)
        return true
      } else {
        this.$root.$emit('wrong-input')
        return false
      }
    },
    changeTravelDate(range) {
      this.data.range_dates.travel_date_from = range.start
      this.data.range_dates.travel_date_to = range.end
    },
  },
  mounted() {
    var api = new RatesApi()
    api.getRates(this.$root.hotelId, (error, data) => {
      if (data.filter((t) => t['id'] == 'BAR').length > 0) {
        this.data.rate_ids = ['BAR']
      }
    })
  },
  watch: {
    'data.channels_online': function() {
      this.data.channel_ids = []
    },
  },
}
</script>

<style lang="scss">
@import 'src/assets/scss/md/_variables.scss';

.pricing-modal {
  .has-error {
    color: $red;
    .md-icon.md-theme-default.md-icon-font {
      color: $red;
    }
  }
  .text-left {
    text-align: left !important;
  }
  .with-border {
    border: solid 1px #aaa;
    margin-bottom: 1em;
  }
  .md-toolbar {
    z-index: unset;
    .md-field {
      width: auto;
      &.md-datepicker {
        width: 160px;
      }
    }
  }
  .md-radio,
  .md-switch {
    margin-bottom: 0;
  }

  @media (min-width: 1100px) {
    &.big-modal .modal-container {
      max-width: 1024px;
    }
  }

  &.modal-mask {
    z-index: 11 !important;
  }

  .md-field .success.md-icon,
  .md-field .error.md-icon {
    bottom: 5px;
  }
}
</style>
